
      (() => {
      /* ------------------ PASTE YOUR MATRIXIFY DATA HERE ------------------ */
      // Paste the Matrixify "Address – Countries and Provinces" table as **plain text**.
      // One entry per line, e.g.:
      // United States US Alabama AL
      // United States US Alaska AK
      // Canada CA Ontario ON
      // Canada CA Quebec QC
      // Spain ES
      // (Countries without provinces appear only with country name + 2-letter code.)
      const MATRIXIFY_RAW = `
      Afghanistan AF
      Aland Islands AX
      Albania AL
      Algeria DZ
      Andorra AD
      Angola AO
      Anguilla AI
      Antigua And Barbuda AG
      Argentina AR Buenos Aires B
      Argentina AR Catamarca K
      Argentina AR Chaco H
      Argentina AR Chubut U
      Argentina AR Ciudad Autónoma de Buenos Aires C
      Argentina AR Córdoba X
      Argentina AR Corrientes W
      Argentina AR Entre Ríos E
      Argentina AR Formosa P
      Argentina AR Jujuy Y
      Argentina AR La Pampa L
      Argentina AR La Rioja F
      Argentina AR Mendoza M
      Argentina AR Misiones N
      Argentina AR Neuquén Q
      Argentina AR Río Negro R
      Argentina AR Salta A
      Argentina AR San Juan J
      Argentina AR San Luis D
      Argentina AR Santa Cruz Z
      Argentina AR Santa Fe S
      Argentina AR Santiago Del Estero G
      Argentina AR Tierra Del Fuego V
      Argentina AR Tucumán T
      Armenia AM
      Aruba AW
      Ascension Island AC
      Australia AU Australian Capital Territory ACT
      Australia AU New South Wales NSW
      Australia AU Northern Territory NT
      Australia AU Queensland QLD
      Australia AU South Australia SA
      Australia AU Tasmania TAS
      Australia AU Victoria VIC
      Australia AU Western Australia WA
      Austria AT
      Azerbaijan AZ
      Bahamas BS
      Bahrain BH
      Bangladesh BD
      Barbados BB
      Belarus BY
      Belgium BE
      Belize BZ
      Benin BJ
      Bermuda BM
      Bhutan BT
      Bolivia BO
      Bosnia And Herzegovina BA
      Botswana BW
      Bouvet Island BV
      Brazil BR Acre AC
      Brazil BR Alagoas AL
      Brazil BR Amapá AP
      Brazil BR Amazonas AM
      Brazil BR Bahia BA
      Brazil BR Ceará CE
      Brazil BR Distrito Federal DF
      Brazil BR Espírito Santo ES
      Brazil BR Goiás GO
      Brazil BR Maranhão MA
      Brazil BR Mato Grosso MT
      Brazil BR Mato Grosso do Sul MS
      Brazil BR Minas Gerais MG
      Brazil BR Pará PA
      Brazil BR Paraíba PB
      Brazil BR Paraná PR
      Brazil BR Pernambuco PE
      Brazil BR Piauí PI
      Brazil BR Rio de Janeiro RJ
      Brazil BR Rio Grande do Norte RN
      Brazil BR Rio Grande do Sul RS
      Brazil BR Rondônia RO
      Brazil BR Roraima RR
      Brazil BR Santa Catarina SC
      Brazil BR São Paulo SP
      Brazil BR Sergipe SE
      Brazil BR Tocantins TO
      British Indian Ocean Territory IO
      Brunei BN
      Bulgaria BG
      Burkina Faso BF
      Burundi BI
      Cambodia KH
      Canada CA Alberta AB
      Canada CA British Columbia BC
      Canada CA Manitoba MB
      Canada CA New Brunswick NB
      Canada CA Newfoundland and Labrador NL
      Canada CA Northwest Territories NT
      Canada CA Nova Scotia NS
      Canada CA Nunavut NU
      Canada CA Ontario ON
      Canada CA Prince Edward Island PE
      Canada CA Quebec QC
      Canada CA Saskatchewan SK
      Canada CA Yukon YT
      Cape Verde CV
      Caribbean Netherlands BQ
      Cayman Islands KY
      Central African Republic CF
      Chad TD
      Chile CL Arica and Parinacota AP
      Chile CL Tarapacá TA
      Chile CL Antofagasta AN
      Chile CL Atacama AT
      Chile CL Coquimbo CO
      Chile CL Valparaíso VS
      Chile CL Santiago RM
      Chile CL O’Higgins LI
      Chile CL Maule ML
      Chile CL Ñuble NB
      Chile CL Biobío BI
      Chile CL Araucanía AR
      Chile CL Los Ríos LR
      Chile CL Los Lagos LL
      Chile CL Aysén AI
      Chile CL Magallanes MA
      China CN Anhui AH
      China CN Beijing BJ
      China CN Chongqing CQ
      China CN Fujian FJ
      China CN Gansu GS
      China CN Guangdong GD
      China CN Guangxi GX
      China CN Guizhou GZ
      China CN Hainan HI
      China CN Hebei HE
      China CN Heilongjiang HL
      China CN Henan HA
      China CN Hubei HB
      China CN Hunan HN
      China CN Inner Mongolia NM
      China CN Jiangsu JS
      China CN Jiangxi JX
      China CN Jilin JL
      China CN Liaoning LN
      China CN Ningxia NX
      China CN Qinghai QH
      China CN Shaanxi SN
      China CN Shandong SD
      China CN Shanghai SH
      China CN Shanxi SX
      China CN Sichuan SC
      China CN Tianjin TJ
      China CN Xinjiang XJ
      China CN Xizang YZ
      China CN Yunnan YN
      China CN Zhejiang ZJ
      Christmas Island CX
      Cocos (Keeling) Islands CC
      Colombia CO Amazonas AMA
      Colombia CO Antioquia ANT
      Colombia CO Arauca ARA
      Colombia CO Atlántico ATL
      Colombia CO Bogotá, D.C. DC
      Colombia CO Bolívar BOL
      Colombia CO Boyacá BOY
      Colombia CO Caldas CAL
      Colombia CO Caquetá CAQ
      Colombia CO Casanare CAS
      Colombia CO Cauca CAU
      Colombia CO Cesar CES
      Colombia CO Chocó CHO
      Colombia CO Córdoba COR
      Colombia CO Cundinamarca CUN
      Colombia CO Guainía GUA
      Colombia CO Guaviare GUV
      Colombia CO Huila HUI
      Colombia CO La Guajira LAG
      Colombia CO Magdalena MAG
      Colombia CO Meta MET
      Colombia CO Nariño NAR
      Colombia CO Norte de Santander NSA
      Colombia CO Putumayo PUT
      Colombia CO Quindío QUI
      Colombia CO Risaralda RIS
      Colombia CO San Andrés, Providencia y Santa Catalina SAP
      Colombia CO Santander SAN
      Colombia CO Sucre SUC
      Colombia CO Tolima TOL
      Colombia CO Valle del Cauca VAC
      Colombia CO Vaupés VAU
      Colombia CO Vichada VID
      Comoros KM
      Congo CG
      Congo, The Democratic Republic Of The CD
      Cook Islands CK
      Costa Rica CR
      Croatia HR
      Cuba CU
      Curaçao CW
      Cyprus CY
      Czech Republic CZ
      Côte d’Ivoire CI
      Denmark DK
      Djibouti DJ
      Dominica DM
      Dominican Republic DO
      Ecuador EC
      Egypt EG 6th of October SU
      Egypt EG Al Sharqia SHR
      Egypt EG Alexandria ALX
      Egypt EG Aswan ASN
      Egypt EG Asyut AST
      Egypt EG Beheira BH
      Egypt EG Beni Suef BNS
      Egypt EG Cairo C
      Egypt EG Dakahlia DK
      Egypt EG Damietta DT
      Egypt EG Faiyum FYM
      Egypt EG Gharbia GH
      Egypt EG Giza GZ
      Egypt EG Helwan HU
      Egypt EG Ismailia IS
      Egypt EG Kafr el-Sheikh KFS
      Egypt EG Luxor LX
      Egypt EG Matrouh MT
      Egypt EG Minya MN
      Egypt EG Monufia MNF
      Egypt EG New Valley WAD
      Egypt EG North Sinai SIN
      Egypt EG Port Said PTS
      Egypt EG Qalyubia KB
      Egypt EG Qena KN
      Egypt EG Red Sea BA
      Egypt EG Sohag SHG
      Egypt EG South Sinai JS
      Egypt EG Suez SUZ
      El Salvador SV
      Equatorial Guinea GQ
      Eritrea ER
      Estonia EE
      Eswatini SZ
      Ethiopia ET
      Falkland Islands (Malvinas) FK
      Faroe Islands FO
      Fiji FJ
      Finland FI
      France FR
      French Guiana GF
      French Polynesia PF
      French Southern Territories TF
      Gabon GA
      Gambia GM
      Georgia GE
      Germany DE
      Ghana GH
      Gibraltar GI
      Greece GR
      Greenland GL
      Grenada GD
      Guadeloupe GP
      Guatemala GT Alta Verapaz AVE
      Guatemala GT Baja Verapaz BVE
      Guatemala GT Chimaltenango CMT
      Guatemala GT Chiquimula CQM
      Guatemala GT El Progreso EPR
      Guatemala GT Escuintla ESC
      Guatemala GT Guatemala GUA
      Guatemala GT Huehuetenango HUE
      Guatemala GT Izabal IZA
      Guatemala GT Jalapa JAL
      Guatemala GT Jutiapa JUT
      Guatemala GT Petén PET
      Guatemala GT Quetzaltenango QUE
      Guatemala GT Quiché QUI
      Guatemala GT Retalhuleu RET
      Guatemala GT Sacatepéquez SAC
      Guatemala GT San Marcos SMA
      Guatemala GT Santa Rosa SRO
      Guatemala GT Sololá SOL
      Guatemala GT Suchitepéquez SUC
      Guatemala GT Totonicapán TOT
      Guatemala GT Zacapa ZAC
      Guernsey GG
      Guinea GN
      Guinea Bissau GW
      Guyana GY
      Haiti HT
      Heard Island And Mcdonald Islands HM
      Holy See (Vatican City State) VA
      Honduras HN
      Hong Kong HK Hong Kong Island HK
      Hong Kong HK Kowloon KL
      Hong Kong HK New Territories NT
      Hungary HU
      Iceland IS
      India IN Andaman and Nicobar Islands AN
      India IN Andhra Pradesh AP
      India IN Arunachal Pradesh AR
      India IN Assam AS
      India IN Bihar BR
      India IN Chandigarh CH
      India IN Chhattisgarh CG
      India IN Dadra and Nagar Haveli DN
      India IN Daman and Diu DD
      India IN Delhi DL
      India IN Goa GA
      India IN Gujarat GJ
      India IN Haryana HR
      India IN Himachal Pradesh HP
      India IN Jammu and Kashmir JK
      India IN Jharkhand JH
      India IN Karnataka KA
      India IN Kerala KL
      India IN Ladakh LA
      India IN Lakshadweep LD
      India IN Madhya Pradesh MP
      India IN Maharashtra MH
      India IN Manipur MN
      India IN Meghalaya ML
      India IN Mizoram MZ
      India IN Nagaland NL
      India IN Odisha OR
      India IN Puducherry PY
      India IN Punjab PB
      India IN Rajasthan RJ
      India IN Sikkim SK
      India IN Tamil Nadu TN
      India IN Telangana TS
      India IN Tripura TR
      India IN Uttar Pradesh UP
      India IN Uttarakhand UK
      India IN West Bengal WB
      Indonesia ID Aceh AC
      Indonesia ID Bali BA
      Indonesia ID Bangka Belitung BB
      Indonesia ID Banten BT
      Indonesia ID Bengkulu BE
      Indonesia ID Gorontalo GO
      Indonesia ID Jakarta JK
      Indonesia ID Jambi JA
      Indonesia ID Jawa Barat JB
      Indonesia ID Jawa Tengah JT
      Indonesia ID Jawa Timur JI
      Indonesia ID Kalimantan Barat KB
      Indonesia ID Kalimantan Selatan KS
      Indonesia ID Kalimantan Tengah KT
      Indonesia ID Kalimantan Timur KI
      Indonesia ID Kalimantan Utara KU
      Indonesia ID Kepulauan Riau KR
      Indonesia ID Lampung LA
      Indonesia ID Maluku MA
      Indonesia ID Maluku Utara MU
      Indonesia ID North Sumatra SU
      Indonesia ID Nusa Tenggara Barat NB
      Indonesia ID Nusa Tenggara Timur NT
      Indonesia ID Papua PA
      Indonesia ID Papua Barat PB
      Indonesia ID Riau RI
      Indonesia ID South Sumatra SS
      Indonesia ID Sulawesi Barat SR
      Indonesia ID Sulawesi Selatan SN
      Indonesia ID Sulawesi Tengah ST
      Indonesia ID Sulawesi Tenggara SG
      Indonesia ID Sulawesi Utara SA
      Indonesia ID West Sumatra SB
      Indonesia ID Yogyakarta YO
      Iran, Islamic Republic Of IR
      Iraq IQ
      Ireland IE Carlow CW
      Ireland IE Cavan CN
      Ireland IE Clare CE
      Ireland IE Cork CO
      Ireland IE Donegal DL
      Ireland IE Dublin D
      Ireland IE Galway G
      Ireland IE Kerry KY
      Ireland IE Kildare KE
      Ireland IE Kilkenny KK
      Ireland IE Laois LS
      Ireland IE Leitrim LM
      Ireland IE Limerick LK
      Ireland IE Longford LD
      Ireland IE Louth LH
      Ireland IE Mayo MO
      Ireland IE Meath MH
      Ireland IE Monaghan MN
      Ireland IE Offaly OY
      Ireland IE Roscommon RN
      Ireland IE Sligo SO
      Ireland IE Tipperary TA
      Ireland IE Waterford WD
      Ireland IE Westmeath WH
      Ireland IE Wexford WX
      Ireland IE Wicklow WW
      Isle Of Man IM
      Israel IL
      Italy IT Agrigento AG
      Italy IT Alessandria AL
      Italy IT Ancona AN
      Italy IT Aosta AO
      Italy IT Arezzo AR
      Italy IT Ascoli Piceno AP
      Italy IT Asti AT
      Italy IT Avellino AV
      Italy IT Bari BA
      Italy IT Barletta-Andria-Trani BT
      Italy IT Belluno BL
      Italy IT Benevento BN
      Italy IT Bergamo BG
      Italy IT Biella BI
      Italy IT Bologna BO
      Italy IT Bolzano BZ
      Italy IT Brescia BS
      Italy IT Brindisi BR
      Italy IT Cagliari CA
      Italy IT Caltanissetta CL
      Italy IT Campobasso CB
      Italy IT Carbonia-Iglesias CI
      Italy IT Caserta CE
      Italy IT Catania CT
      Italy IT Catanzaro CZ
      Italy IT Chieti CH
      Italy IT Como CO
      Italy IT Cosenza CS
      Italy IT Cremona CR
      Italy IT Crotone KR
      Italy IT Cuneo CN
      Italy IT Enna EN
      Italy IT Fermo FM
      Italy IT Ferrara FE
      Italy IT Firenze FI
      Italy IT Foggia FG
      Italy IT Forlì-Cesena FC
      Italy IT Frosinone FR
      Italy IT Genova GE
      Italy IT Gorizia GO
      Italy IT Grosseto GR
      Italy IT Imperia IM
      Italy IT Isernia IS
      Italy IT L’Aquila AQ
      Italy IT La Spezia SP
      Italy IT Latina LT
      Italy IT Lecce LE
      Italy IT Lecco LC
      Italy IT Livorno LI
      Italy IT Lodi LO
      Italy IT Lucca LU
      Italy IT Macerata MC
      Italy IT Mantova MN
      Italy IT Massa-Carrara MS
      Italy IT Matera MT
      Italy IT Medio Campidano VS
      Italy IT Messina ME
      Italy IT Milano MI
      Italy IT Modena MO
      Italy IT Monza e Brianza MB
      Italy IT Napoli NA
      Italy IT Novara NO
      Italy IT Nuoro NU
      Italy IT Ogliastra OG
      Italy IT Olbia-Tempio OT
      Italy IT Oristano OR
      Italy IT Padova PD
      Italy IT Palermo PA
      Italy IT Parma PR
      Italy IT Pavia PV
      Italy IT Perugia PG
      Italy IT Pesaro e Urbino PU
      Italy IT Pescara PE
      Italy IT Piacenza PC
      Italy IT Pisa PI
      Italy IT Pistoia PT
      Italy IT Pordenone PN
      Italy IT Potenza PZ
      Italy IT Prato PO
      Italy IT Ragusa RG
      Italy IT Ravenna RA
      Italy IT Reggio Calabria RC
      Italy IT Reggio Emilia RE
      Italy IT Rieti RI
      Italy IT Rimini RN
      Italy IT Roma RM
      Italy IT Rovigo RO
      Italy IT Salerno SA
      Italy IT Sassari SS
      Italy IT Savona SV
      Italy IT Siena SI
      Italy IT Siracusa SR
      Italy IT Sondrio SO
      Italy IT Taranto TA
      Italy IT Teramo TE
      Italy IT Terni TR
      Italy IT Torino TO
      Italy IT Trapani TP
      Italy IT Trento TN
      Italy IT Treviso TV
      Italy IT Trieste TS
      Italy IT Udine UD
      Italy IT Varese VA
      Italy IT Venezia VE
      Italy IT Verbano-Cusio-Ossola VB
      Italy IT Vercelli VC
      Italy IT Verona VR
      Italy IT Vibo Valentia VV
      Italy IT Vicenza VI
      Italy IT Viterbo VT
      Jamaica JM
      Japan JP Hokkaidō JP-01
      Japan JP Aomori JP-02
      Japan JP Iwate JP-03
      Japan JP Miyagi JP-04
      Japan JP Akita JP-05
      Japan JP Yamagata JP-06
      Japan JP Fukushima JP-07
      Japan JP Ibaraki JP-08
      Japan JP Tochigi JP-09
      Japan JP Gunma JP-10
      Japan JP Saitama JP-11
      Japan JP Chiba JP-12
      Japan JP Tōkyō JP-13
      Japan JP Kanagawa JP-14
      Japan JP Niigata JP-15
      Japan JP Toyama JP-16
      Japan JP Ishikawa JP-17
      Japan JP Fukui JP-18
      Japan JP Yamanashi JP-19
      Japan JP Nagano JP-20
      Japan JP Gifu JP-21
      Japan JP Shizuoka JP-22
      Japan JP Aichi JP-23
      Japan JP Mie JP-24
      Japan JP Shiga JP-25
      Japan JP Kyōto JP-26
      Japan JP Ōsaka JP-27
      Japan JP Hyōgo JP-28
      Japan JP Nara JP-29
      Japan JP Wakayama JP-30
      Japan JP Tottori JP-31
      Japan JP Shimane JP-32
      Japan JP Okayama JP-33
      Japan JP Hiroshima JP-34
      Japan JP Yamaguchi JP-35
      Japan JP Tokushima JP-36
      Japan JP Kagawa JP-37
      Japan JP Ehime JP-38
      Japan JP Kōchi JP-39
      Japan JP Fukuoka JP-40
      Japan JP Saga JP-41
      Japan JP Nagasaki JP-42
      Japan JP Kumamoto JP-43
      Japan JP Ōita JP-44
      Japan JP Miyazaki JP-45
      Japan JP Kagoshima JP-46
      Japan JP Okinawa JP-47
      Jersey JE
      Jordan JO
      Kazakhstan KZ
      Kenya KE
      Kiribati KI
      Korea, Democratic People’s Republic Of KP
      Kosovo XK
      Kuwait KW
      Kyrgyzstan KG
      Lao People’s Democratic Republic LA
      Latvia LV
      Lebanon LB
      Lesotho LS
      Liberia LR
      Libyan Arab Jamahiriya LY
      Liechtenstein LI
      Lithuania LT
      Luxembourg LU
      Macao MO
      Madagascar MG
      Malawi MW
      Malaysia MY Johor JHR
      Malaysia MY Kedah KDH
      Malaysia MY Kelantan KTN
      Malaysia MY Kuala Lumpur KUL
      Malaysia MY Labuan LBN
      Malaysia MY Melaka MLK
      Malaysia MY Negeri Sembilan NSN
      Malaysia MY Pahang PHG
      Malaysia MY Penang PNG
      Malaysia MY Perak PRK
      Malaysia MY Perlis PLS
      Malaysia MY Putrajaya PJY
      Malaysia MY Sabah SBH
      Malaysia MY Sarawak SWK
      Malaysia MY Selangor SGR
      Malaysia MY Terengganu TRG
      Maldives MV
      Mali ML
      Malta MT
      Martinique MQ
      Mauritania MR
      Mauritius MU
      Mayotte YT
      Mexico MX Aguascalientes AGS
      Mexico MX Baja California BC
      Mexico MX Baja California Sur BCS
      Mexico MX Campeche CAMP
      Mexico MX Chiapas CHIS
      Mexico MX Chihuahua CHIH
      Mexico MX Ciudad de México DF
      Mexico MX Coahuila COAH
      Mexico MX Colima COL
      Mexico MX Durango DGO
      Mexico MX Guanajuato GTO
      Mexico MX Guerrero GRO
      Mexico MX Hidalgo HGO
      Mexico MX Jalisco JAL
      Mexico MX México MEX
      Mexico MX Michoacán MICH
      Mexico MX Morelos MOR
      Mexico MX Nayarit NAY
      Mexico MX Nuevo León NL
      Mexico MX Oaxaca OAX
      Mexico MX Puebla PUE
      Mexico MX Querétaro QRO
      Mexico MX Quintana Roo Q ROO
      Mexico MX San Luis Potosí SLP
      Mexico MX Sinaloa SIN
      Mexico MX Sonora SON
      Mexico MX Tabasco TAB
      Mexico MX Tamaulipas TAMPS
      Mexico MX Tlaxcala TLAX
      Mexico MX Veracruz VER
      Mexico MX Yucatán YUC
      Mexico MX Zacatecas ZAC
      Moldova, Republic of MD
      Monaco MC
      Mongolia MN
      Montenegro ME
      Montserrat MS
      Morocco MA
      Mozambique MZ
      Myanmar MM
      Namibia NA
      Nauru NR
      Nepal NP
      Netherlands NL
      Netherlands Antilles AN
      New Caledonia NC
      New Zealand NZ Auckland AUK
      New Zealand NZ Bay of Plenty BOP
      New Zealand NZ Canterbury CAN
      New Zealand NZ Chatham Islands CIT
      New Zealand NZ Gisborne GIS
      New Zealand NZ Hawke’s Bay HKB
      New Zealand NZ Manawatu-Wanganui MWT
      New Zealand NZ Marlborough MBH
      New Zealand NZ Nelson NSN
      New Zealand NZ Northland NTL
      New Zealand NZ Otago OTA
      New Zealand NZ Southland STL
      New Zealand NZ Taranaki TKI
      New Zealand NZ Tasman TAS
      New Zealand NZ Waikato WKO
      New Zealand NZ Wellington WGN
      New Zealand NZ West Coast WTC
      Nicaragua NI
      Niger NE
      Nigeria NG Abia AB
      Nigeria NG Abuja Federal Capital Territory FC
      Nigeria NG Adamawa AD
      Nigeria NG Akwa Ibom AK
      Nigeria NG Anambra AN
      Nigeria NG Bauchi BA
      Nigeria NG Bayelsa BY
      Nigeria NG Benue BE
      Nigeria NG Borno BO
      Nigeria NG Cross River CR
      Nigeria NG Delta DE
      Nigeria NG Ebonyi EB
      Nigeria NG Edo ED
      Nigeria NG Ekiti EK
      Nigeria NG Enugu EN
      Nigeria NG Gombe GO
      Nigeria NG Imo IM
      Nigeria NG Jigawa JI
      Nigeria NG Kaduna KD
      Nigeria NG Kano KN
      Nigeria NG Katsina KT
      Nigeria NG Kebbi KE
      Nigeria NG Kogi KO
      Nigeria NG Kwara KW
      Nigeria NG Lagos LA
      Nigeria NG Nasarawa NA
      Nigeria NG Niger NI
      Nigeria NG Ogun OG
      Nigeria NG Ondo ON
      Nigeria NG Osun OS
      Nigeria NG Oyo OY
      Nigeria NG Plateau PL
      Nigeria NG Rivers RI
      Nigeria NG Sokoto SO
      Nigeria NG Taraba TA
      Nigeria NG Yobe YO
      Nigeria NG Zamfara ZA
      Niue NU
      Norfolk Island NF
      North Macedonia MK
      Norway NO
      Oman OM
      Pakistan PK
      Palestinian Territory, Occupied PS
      Panama PA Bocas del Toro PA-1
      Panama PA Chiriquí PA-4
      Panama PA Coclé PA-2
      Panama PA Colón PA-3
      Panama PA Darién PA-5
      Panama PA Emberá PA-EM
      Panama PA Herrera PA-6
      Panama PA Kuna Yala PA-KY
      Panama PA Los Santos PA-7
      Panama PA Ngöbe-Buglé PA-NB
      Panama PA Panamá PA-8
      Panama PA Panamá Oeste PA-10
      Panama PA Veraguas PA-9
      Papua New Guinea PG
      Paraguay PY
      Peru PE Amazonas PE-AMA
      Peru PE Áncash PE-ANC
      Peru PE Apurímac PE-APU
      Peru PE Arequipa PE-ARE
      Peru PE Ayacucho PE-AYA
      Peru PE Cajamarca PE-CAJ
      Peru PE Callao PE-CAL
      Peru PE Cuzco PE-CUS
      Peru PE Huancavelica PE-HUV
      Peru PE Huánuco PE-HUC
      Peru PE Ica PE-ICA
      Peru PE Junín PE-JUN
      Peru PE La Libertad PE-LAL
      Peru PE Lambayeque PE-LAM
      Peru PE Lima (departamento) PE-LIM
      Peru PE Lima (provincia) PE-LMA
      Peru PE Loreto PE-LOR
      Peru PE Madre de Dios PE-MDD
      Peru PE Moquegua PE-MOQ
      Peru PE Pasco PE-PAS
      Peru PE Piura PE-PIU
      Peru PE Puno PE-PUN
      Peru PE San Martín PE-SAM
      Peru PE Tacna PE-TAC
      Peru PE Tumbes PE-TUM
      Peru PE Ucayali PE-UCA
      Philippines PH Abra PH-ABR
      Philippines PH Agusan del Norte PH-AGN
      Philippines PH Agusan del Sur PH-AGS
      Philippines PH Aklan PH-AKL
      Philippines PH Albay PH-ALB
      Philippines PH Antique PH-ANT
      Philippines PH Apayao PH-APA
      Philippines PH Aurora PH-AUR
      Philippines PH Basilan PH-BAS
      Philippines PH Bataan PH-BAN
      Philippines PH Batanes PH-BTN
      Philippines PH Batangas PH-BTG
      Philippines PH Benguet PH-BEN
      Philippines PH Biliran PH-BIL
      Philippines PH Bohol PH-BOH
      Philippines PH Bukidnon PH-BUK
      Philippines PH Bulacan PH-BUL
      Philippines PH Cagayan PH-CAG
      Philippines PH Camarines Norte PH-CAN
      Philippines PH Camarines Sur PH-CAS
      Philippines PH Camiguin PH-CAM
      Philippines PH Capiz PH-CAP
      Philippines PH Catanduanes PH-CAT
      Philippines PH Cavite PH-CAV
      Philippines PH Cebu PH-CEB
      Philippines PH Cotabato PH-NCO
      Philippines PH Davao de Oro PH-COM
      Philippines PH Davao del Norte PH-DAV
      Philippines PH Davao del Sur PH-DAS
      Philippines PH Davao Occidental PH-DVO
      Philippines PH Davao Oriental PH-DAO
      Philippines PH Dinagat Islands PH-DIN
      Philippines PH Eastern Samar PH-EAS
      Philippines PH Guimaras PH-GUI
      Philippines PH Ifugao PH-IFU
      Philippines PH Ilocos Norte PH-ILN
      Philippines PH Ilocos Sur PH-ILS
      Philippines PH Iloilo PH-ILI
      Philippines PH Isabela PH-ISA
      Philippines PH Kalinga PH-KAL
      Philippines PH La Union PH-LUN
      Philippines PH Laguna PH-LAG
      Philippines PH Lanao del Norte PH-LAN
      Philippines PH Lanao del Sur PH-LAS
      Philippines PH Leyte PH-LEY
      Philippines PH Maguindanao PH-MAG
      Philippines PH Marinduque PH-MAD
      Philippines PH Masbate PH-MAS
      Philippines PH Metro Manila PH-00
      Philippines PH Misamis Occidental PH-MSC
      Philippines PH Misamis Oriental PH-MSR
      Philippines PH Mountain Province PH-MOU
      Philippines PH Negros Occidental PH-NEC
      Philippines PH Negros Oriental PH-NER
      Philippines PH Northern Samar PH-NSA
      Philippines PH Nueva Ecija PH-NUE
      Philippines PH Nueva Vizcaya PH-NUV
      Philippines PH Occidental Mindoro PH-MDC
      Philippines PH Oriental Mindoro PH-MDR
      Philippines PH Palawan PH-PLW
      Philippines PH Pampanga PH-PAM
      Philippines PH Pangasinan PH-PAN
      Philippines PH Quezon PH-QUE
      Philippines PH Quirino PH-QUI
      Philippines PH Rizal PH-RIZ
      Philippines PH Romblon PH-ROM
      Philippines PH Samar PH-WSA
      Philippines PH Sarangani PH-SAR
      Philippines PH Siquijor PH-SIG
      Philippines PH Sorsogon PH-SOR
      Philippines PH South Cotabato PH-SCO
      Philippines PH Southern Leyte PH-SLE
      Philippines PH Sultan Kudarat PH-SUK
      Philippines PH Sulu PH-SLU
      Philippines PH Surigao del Norte PH-SUN
      Philippines PH Surigao del Sur PH-SUR
      Philippines PH Tarlac PH-TAR
      Philippines PH Tawi-Tawi PH-TAW
      Philippines PH Zambales PH-ZMB
      Philippines PH Zamboanga del Norte PH-ZAN
      Philippines PH Zamboanga del Sur PH-ZAS
      Philippines PH Zamboanga Sibugay PH-ZSI
      Pitcairn PN
      Poland PL
      Portugal PT Açores PT-20
      Portugal PT Aveiro PT-01
      Portugal PT Beja PT-02
      Portugal PT Braga PT-03
      Portugal PT Bragança PT-04
      Portugal PT Castelo Branco PT-05
      Portugal PT Coimbra PT-06
      Portugal PT Évora PT-07
      Portugal PT Faro PT-08
      Portugal PT Guarda PT-09
      Portugal PT Leiria PT-10
      Portugal PT Lisboa PT-11
      Portugal PT Madeira PT-30
      Portugal PT Portalegre PT-12
      Portugal PT Porto PT-13
      Portugal PT Santarém PT-14
      Portugal PT Setúbal PT-15
      Portugal PT Viana do Castelo PT-16
      Portugal PT Vila Real PT-17
      Portugal PT Viseu PT-18
      Qatar QA
      Republic of Cameroon CM
      Reunion RE
      Romania RO Alba AB
      Romania RO Arad AR
      Romania RO Argeș AG
      Romania RO Bacău BC
      Romania RO Bihor BH
      Romania RO Bistrița-Năsăud BN
      Romania RO Botoșani BT
      Romania RO Brașov BV
      Romania RO Brăila BR
      Romania RO București B
      Romania RO Buzău BZ
      Romania RO Călărași CL
      Romania RO Caraș-Severin CS
      Romania RO Cluj CJ
      Romania RO Constanța CT
      Romania RO Covasna CV
      Romania RO Dâmbovița DB
      Romania RO Dolj DJ
      Romania RO Galați GL
      Romania RO Giurgiu GR
      Romania RO Gorj GJ
      Romania RO Harghita HR
      Romania RO Hunedoara HD
      Romania RO Iași IS
      Romania RO Ialomița IL
      Romania RO Ilfov IF
      Romania RO Maramureș MM
      Romania RO Mehedinți MH
      Romania RO Mureș MS
      Romania RO Neamț NT
      Romania RO Olt OT
      Romania RO Prahova PH
      Romania RO Sălaj SJ
      Romania RO Satu Mare SM
      Romania RO Sibiu SB
      Romania RO Suceava SV
      Romania RO Teleorman TR
      Romania RO Timiș TM
      Romania RO Tulcea TL
      Romania RO Vâlcea VL
      Romania RO Vaslui VS
      Romania RO Vrancea VN
      Russia RU Republic of Adygeya AD
      Russia RU Altai Republic AL
      Russia RU Altai Krai ALT
      Russia RU Amur Oblast AMU
      Russia RU Arkhangelsk Oblast ARK
      Russia RU Astrakhan Oblast AST
      Russia RU Republic of Bashkortostan BA
      Russia RU Belgorod Oblast BEL
      Russia RU Bryansk Oblast BRY
      Russia RU Republic of Buryatia BU
      Russia RU Chechen Republic CE
      Russia RU Chelyabinsk Oblast CHE
      Russia RU Chukotka Autonomous Okrug CHU
      Russia RU Chuvash Republic CU
      Russia RU Republic of Dagestan DA
      Russia RU Republic of Ingushetia IN
      Russia RU Irkutsk Oblast IRK
      Russia RU Ivanovo Oblast IVA
      Russia RU Jewish Autonomous Oblast YEV
      Russia RU Kabardino-Balkarian Republic KB
      Russia RU Kaliningrad Oblast KGD
      Russia RU Republic of Kalmykia KL
      Russia RU Kaluga Oblast KLU
      Russia RU Kamchatka Krai KAM
      Russia RU Karachay–Cherkess Republic KC
      Russia RU Republic of Karelia KR
      Russia RU Kemerovo Oblast KEM
      Russia RU Khabarovsk Krai KHA
      Russia RU Republic of Khakassia KK
      Russia RU Khanty-Mansi Autonomous Okrug KHM
      Russia RU Kirov Oblast KIR
      Russia RU Komi Republic KO
      Russia RU Kostroma Oblast KOS
      Russia RU Krasnodar Krai KDA
      Russia RU Krasnoyarsk Krai KYA
      Russia RU Kurgan Oblast KGN
      Russia RU Kursk Oblast KRS
      Russia RU Leningrad Oblast LEN
      Russia RU Lipetsk Oblast LIP
      Russia RU Magadan Oblast MAG
      Russia RU Mari El Republic ME
      Russia RU Republic of Mordovia MO
      Russia RU Moscow MOW
      Russia RU Moscow Oblast MOS
      Russia RU Murmansk Oblast MUR
      Russia RU Nizhny Novgorod Oblast NIZ
      Russia RU Novgorod Oblast NGR
      Russia RU Novosibirsk Oblast NVS
      Russia RU Omsk Oblast OMS
      Russia RU Orenburg Oblast ORE
      Russia RU Oryol Oblast ORL
      Russia RU Penza Oblast PNZ
      Russia RU Perm Krai PER
      Russia RU Primorsky Krai PRI
      Russia RU Pskov Oblast PSK
      Russia RU Rostov Oblast ROS
      Russia RU Ryazan Oblast RYA
      Russia RU Saint Petersburg SPE
      Russia RU Sakha Republic (Yakutia) SA
      Russia RU Sakhalin Oblast SAK
      Russia RU Samara Oblast SAM
      Russia RU Saratov Oblast SAR
      Russia RU Republic of North Ossetia–Alania SE
      Russia RU Smolensk Oblast SMO
      Russia RU Stavropol Krai STA
      Russia RU Sverdlovsk Oblast SVE
      Russia RU Tambov Oblast TAM
      Russia RU Republic of Tatarstan TA
      Russia RU Tomsk Oblast TOM
      Russia RU Tula Oblast TUL
      Russia RU Tver Oblast TVE
      Russia RU Tyumen Oblast TYU
      Russia RU Tyva Republic TY
      Russia RU Udmurtia UD
      Russia RU Ulyanovsk Oblast ULY
      Russia RU Vladimir Oblast VLA
      Russia RU Volgograd Oblast VGG
      Russia RU Vologda Oblast VLG
      Russia RU Voronezh Oblast VOR
      Russia RU Yamalo-Nenets Autonomous Okrug YAN
      Russia RU Yaroslavl Oblast YAR
      Russia RU Zabaykalsky Krai ZAB
      Rwanda RW
      Saint Barthélemy BL
      Saint Helena SH
      Saint Kitts And Nevis KN
      Saint Lucia LC
      Saint Martin MF
      Saint Pierre And Miquelon PM
      Samoa WS
      San Marino SM
      Sao Tome And Principe ST
      Saudi Arabia SA
      Senegal SN
      Serbia RS
      Seychelles SC
      Sierra Leone SL
      Singapore SG
      Sint Maarten SX
      Slovakia SK
      Slovenia SI
      Solomon Islands SB
      Somalia SO
      South Africa ZA Eastern Cape EC
      South Africa ZA Free State FS
      South Africa ZA Gauteng GT
      South Africa ZA KwaZulu-Natal NL
      South Africa ZA Limpopo LP
      South Africa ZA Mpumalanga MP
      South Africa ZA North West NW
      South Africa ZA Northern Cape NC
      South Africa ZA Western Cape WC
      South Georgia And The South Sandwich Islands GS
      South Korea KR Busan KR-26
      South Korea KR Chungbuk KR-43
      South Korea KR Chungnam KR-44
      South Korea KR Daegu KR-27
      South Korea KR Daejeon KR-30
      South Korea KR Gangwon KR-42
      South Korea KR Gwangju KR-29
      South Korea KR Gyeongbuk KR-47
      South Korea KR Gyeonggi KR-41
      South Korea KR Gyeongnam KR-48
      South Korea KR Incheon KR-28
      South Korea KR Jeju KR-49
      South Korea KR Jeonbuk KR-45
      South Korea KR Jeonnam KR-46
      South Korea KR Sejong KR-50
      South Korea KR Seoul KR-11
      South Korea KR Ulsan KR-31
      South Sudan SS
      Spain ES A Coruña C
      Spain ES Álava VI
      Spain ES Albacete AB
      Spain ES Alicante A
      Spain ES Almería AL
      Spain ES Asturias O
      Spain ES Ávila AV
      Spain ES Badajoz BA
      Spain ES Balears PM
      Spain ES Barcelona B
      Spain ES Burgos BU
      Spain ES Cáceres CC
      Spain ES Cádiz CA
      Spain ES Cantabria S
      Spain ES Castellón CS
      Spain ES Ceuta CE
      Spain ES Ciudad Real CR
      Spain ES Córdoba CO
      Spain ES Cuenca CU
      Spain ES Girona GI
      Spain ES Granada GR
      Spain ES Guadalajara GU
      Spain ES Guipúzcoa SS
      Spain ES Huelva H
      Spain ES Huesca HU
      Spain ES Jaén J
      Spain ES La Rioja LO
      Spain ES Las Palmas GC
      Spain ES León LE
      Spain ES Lleida L
      Spain ES Lugo LU
      Spain ES Madrid M
      Spain ES Málaga MA
      Spain ES Melilla ML
      Spain ES Murcia MU
      Spain ES Navarra NA
      Spain ES Ourense OR
      Spain ES Palencia P
      Spain ES Pontevedra PO
      Spain ES Salamanca SA
      Spain ES Santa Cruz de Tenerife TF
      Spain ES Segovia SG
      Spain ES Sevilla SE
      Spain ES Soria SO
      Spain ES Tarragona T
      Spain ES Teruel TE
      Spain ES Toledo TO
      Spain ES Valencia V
      Spain ES Valladolid VA
      Spain ES Vizcaya BI
      Spain ES Zamora ZA
      Spain ES Zaragoza Z
      Sri Lanka LK
      St. Vincent VC
      Sudan SD
      Suriname SR
      Svalbard And Jan Mayen SJ
      Sweden SE
      Switzerland CH
      Syria SY
      Taiwan TW
      Tajikistan TJ
      Tanzania, United Republic Of TZ
      Thailand TH Amnat Charoen TH-37
      Thailand TH Ang Thong TH-15
      Thailand TH Bangkok TH-10
      Thailand TH Bueng Kan TH-38
      Thailand TH Buriram TH-31
      Thailand TH Chachoengsao TH-24
      Thailand TH Chai Nat TH-18
      Thailand TH Chaiyaphum TH-36
      Thailand TH Chanthaburi TH-22
      Thailand TH Chiang Mai TH-50
      Thailand TH Chiang Rai TH-57
      Thailand TH Chon Buri TH-20
      Thailand TH Chumphon TH-86
      Thailand TH Kalasin TH-46
      Thailand TH Kamphaeng Phet TH-62
      Thailand TH Kanchanaburi TH-71
      Thailand TH Khon Kaen TH-40
      Thailand TH Krabi TH-81
      Thailand TH Lampang TH-52
      Thailand TH Lamphun TH-51
      Thailand TH Loei TH-42
      Thailand TH Lopburi TH-16
      Thailand TH Mae Hong Son TH-58
      Thailand TH Maha Sarakham TH-44
      Thailand TH Mukdahan TH-49
      Thailand TH Nakhon Nayok TH-26
      Thailand TH Nakhon Pathom TH-73
      Thailand TH Nakhon Phanom TH-48
      Thailand TH Nakhon Ratchasima TH-30
      Thailand TH Nakhon Sawan TH-60
      Thailand TH Nakhon Si Thammarat TH-80
      Thailand TH Nan TH-55
      Thailand TH Narathiwat TH-96
      Thailand TH Nong Bua Lam Phu TH-39
      Thailand TH Nong Khai TH-43
      Thailand TH Nonthaburi TH-12
      Thailand TH Pathum Thani TH-13
      Thailand TH Pattani TH-94
      Thailand TH Pattaya TH-S
      Thailand TH Phangnga TH-82
      Thailand TH Phatthalung TH-93
      Thailand TH Phayao TH-56
      Thailand TH Phetchabun TH-67
      Thailand TH Phetchaburi TH-76
      Thailand TH Phichit TH-66
      Thailand TH Phitsanulok TH-65
      Thailand TH Phra Nakhon Si Ayutthaya TH-14
      Thailand TH Phrae TH-54
      Thailand TH Phuket TH-83
      Thailand TH Prachin Buri TH-25
      Thailand TH Prachuap Khiri Khan TH-77
      Thailand TH Ranong TH-85
      Thailand TH Ratchaburi TH-70
      Thailand TH Rayong TH-21
      Thailand TH Roi Et TH-45
      Thailand TH Sa Kaeo TH-27
      Thailand TH Sakon Nakhon TH-47
      Thailand TH Samut Prakan TH-11
      Thailand TH Samut Sakhon TH-74
      Thailand TH Samut Songkhram TH-75
      Thailand TH Saraburi TH-19
      Thailand TH Satun TH-91
      Thailand TH Sing Buri TH-17
      Thailand TH Sisaket TH-33
      Thailand TH Songkhla TH-90
      Thailand TH Sukhothai TH-64
      Thailand TH Suphan Buri TH-72
      Thailand TH Surat Thani TH-84
      Thailand TH Surin TH-32
      Thailand TH Tak TH-63
      Thailand TH Trang TH-92
      Thailand TH Trat TH-23
      Thailand TH Ubon Ratchathani TH-34
      Thailand TH Udon Thani TH-41
      Thailand TH Uthai Thani TH-61
      Thailand TH Uttaradit TH-53
      Thailand TH Yala TH-95
      Thailand TH Yasothon TH-35
      Timor Leste TL
      Togo TG
      Tokelau TK
      Tonga TO
      Trinidad and Tobago TT
      Tristan da Cunha TA
      Tunisia TN
      Turkey TR
      Turkmenistan TM
      Turks and Caicos Islands TC
      Tuvalu TV
      Uganda UG
      Ukraine UA
      United Arab Emirates AE Abu Dhabi AZ
      United Arab Emirates AE Ajman AJ
      United Arab Emirates AE Dubai DU
      United Arab Emirates AE Fujairah FU
      United Arab Emirates AE Ras al-Khaimah RK
      United Arab Emirates AE Sharjah SH
      United Arab Emirates AE Umm al-Quwain UQ
      United Kingdom GB British Forces BFP
      United Kingdom GB England ENG
      United Kingdom GB Northern Ireland NIR
      United Kingdom GB Scotland SCT
      United Kingdom GB Wales WLS
      United States US Alabama AL
      United States US Alaska AK
      United States US American Samoa AS
      United States US Arizona AZ
      United States US Arkansas AR
      United States US California CA
      United States US Colorado CO
      United States US Connecticut CT
      United States US Delaware DE
      United States US District of Columbia DC
      United States US Federated States of Micronesia FM
      United States US Florida FL
      United States US Georgia GA
      United States US Guam GU
      United States US Hawaii HI
      United States US Idaho ID
      United States US Illinois IL
      United States US Indiana IN
      United States US Iowa IA
      United States US Kansas KS
      United States US Kentucky KY
      United States US Louisiana LA
      United States US Maine ME
      United States US Marshall Islands MH
      United States US Maryland MD
      United States US Massachusetts MA
      United States US Michigan MI
      United States US Minnesota MN
      United States US Mississippi MS
      United States US Missouri MO
      United States US Montana MT
      United States US Nebraska NE
      United States US Nevada NV
      United States US New Hampshire NH
      United States US New Jersey NJ
      United States US New Mexico NM
      United States US New York NY
      United States US North Carolina NC
      United States US North Dakota ND
      United States US Northern Mariana Islands MP
      United States US Ohio OH
      United States US Oklahoma OK
      United States US Oregon OR
      United States US Palau PW
      United States US Pennsylvania PA
      United States US Puerto Rico PR
      United States US Rhode Island RI
      United States US South Carolina SC
      United States US South Dakota SD
      United States US Tennessee TN
      United States US Texas TX
      United States US Utah UT
      United States US Vermont VT
      United States US Virginia VA
      United States US Washington WA
      United States US West Virginia WV
      United States US Wisconsin WI
      United States US Wyoming WY
      United States US Virgin Islands VI
      United States US Armed Forces Americas AA
      United States US Armed Forces Europe AE
      United States US Armed Forces Pacific AP
      United States Minor Outlying Islands UM
      Uruguay UY
      Uzbekistan UZ
      Vanuatu VU
      Venezuela VE
      Vietnam VN
      Virgin Islands, British VG
      Wallis And Futuna WF
      Western Sahara EH
      Yemen YE
      Zambia ZM
      Zimbabwe ZW
    `.trim();

    /* ------------------ CONFIG / SHORTCUTS ------------------ */
    // Pick the correct forms root per store, with graceful fallbacks
    const FORMS_ATTR = (() => {
      const host = (window.Shopify && Shopify.shop) || location.hostname;

      // explicit mapping
      const map = {
        'cariuma.myshopify.com':         'forms-root-640326', // prod
        'cariuma-testnew.myshopify.com': 'forms-root-620212' // test
      };

      if (map[host]) return map[host];

      // fallback #1: if the embed is already in DOM, read it
      const el = document.querySelector('[data-forms-id^="forms-root-"]');
      if (el) return el.getAttribute('data-forms-id');

      // fallback #2: default to test id (adjust if you prefer prod)
      return 'forms-root-620212';
    })();

    const STYLE_ID   = 'shadow-form-customizations';
    const WRAP_INT   = 'vInterest';
    const WRAP_GEN   = 'vGender';
    const WRAP_CTRY  = 'vCountry';
    const WRAP_PROV  = 'vProvince';
    const EXCLUSIVE_ALL = true;

    const $  = (r,s)=>r.querySelector(s);
    const $$ = (r,s)=>Array.from(r.querySelectorAll(s));

    // --- Helper: wait until the OPEN shadow root exists on the embed ---
    function waitForOpenShadow(formsId, shadowHostSel = 'form-embed, #app-embed', { timeout = 30000, interval = 50 } = {}) {
      return new Promise((resolve, reject) => {
        const deadline = Date.now() + timeout;
        let obs = null, poll = null;

        const cleanup = () => { if (obs) obs.disconnect(); if (poll) clearInterval(poll); };
        const tryResolve = () => {
          const host = document.querySelector(`[data-forms-id="${formsId}"]`);
          if (!host) return false;
          const el = host.querySelector(shadowHostSel);
          if (el && el.shadowRoot) { cleanup(); resolve(el.shadowRoot); return true; }
          return false;
        };

        if (tryResolve()) return;
        obs = new MutationObserver(() => { tryResolve(); });
        obs.observe(document.documentElement, { childList:true, subtree:true });

        poll = setInterval(() => {
          if (tryResolve()) return;
          if (Date.now() > deadline) { cleanup(); reject(new Error('timeout')); }
        }, interval);
      });
    }

    /* ---------- Parse the Matrixify raw table ---------- */
    function buildCountryData(raw) {
      const byCode = Object.create(null);
      const byName = Object.create(null);

      const lines = raw.split(/\r?\n/).map(l => l.trim()).filter(Boolean);
      for (const line of lines) {
        const parts = line.split(/\s+/);
        let ccIdx = -1;
        for (let i = 0; i < parts.length; i++) {
          if (/^[A-Z]{2}$/.test(parts[i])) { ccIdx = i; break; }
        }
        if (ccIdx < 0) continue;

        const countryName = parts.slice(0, ccIdx).join(' ');
        const countryCode = parts[ccIdx];

        if (!byCode[countryCode]) {
          byCode[countryCode] = { name: countryName, provinces: [] };
          byName[countryName] = countryCode;
        }

        if (ccIdx < parts.length - 1) {
          const provCode = parts[parts.length - 1];
          const provName = parts.slice(ccIdx + 1, parts.length - 1).join(' ');
          if (provName && provCode) {
            byCode[countryCode].provinces.push({ name: provName, code: provCode });
          }
        }
      }

      const all = Object.entries(byCode)
        .map(([code, v]) => ({ code, name: v.name }))
        .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }));

      return { byCode, byName, all };
    }

    const COUNTRY_DATA = buildCountryData(MATRIXIFY_RAW);

    /* ---------- Styles: container, headings, components & success banner ---------- */
    function ensureStyles(sr){
      if (!sr) return;

      const css = `
        /* ---------------------------------------------
          TWO-COLUMN LAYOUT – DISABLED (kept for reference)
        ------------------------------------------------
        form[data-testid="form"]{
          display:grid !important;
          grid-template-columns:1fr;
          gap:16px;
          overflow:visible;
        }
        @media (min-width:640px){
          form[data-testid="form"]{ grid-template-columns:repeat(2, minmax(0,1fr)); }
        }
        form[data-testid="form"] > *{ grid-column:span 1; min-width:0; overflow:visible; }
        ------------------------------------------------ */

        /* Popover cutoff fixes */
        section { overflow: visible !important; }
        form[data-testid="form"] { overflow: visible !important; }

        /* Form container width + center */
        form[data-testid="form"]{
          max-width:426px !important;
          margin:0 auto;
        }

        /* Submit button styles + centering */
        form[data-testid="form"] button[type="submit"]{
          min-width:174px;
          text-transform:uppercase;
          text-align:center;
          letter-spacing:1.5px;
          font-weight:700 !important;
          display:block;
          margin:24px auto 15px;
          align-self:center !important;
        }

        /* Section headings */
        .v-section-title{
          color: var(--heading-text-color);
          font-weight: 500;
          margin-bottom: 0;
        }

        /* Disclaimer width to match form */
        ._formDisclaimer_cit2d_38{
          max-width:426px !important;
          margin: 0 auto;
        }

        /* Interest (multi-select) */
        #${WRAP_INT}{ position:relative; font:inherit; }
        #${WRAP_INT} .v-ms__label{ display:none; }
        #${WRAP_INT} .v-ms__control{
          display:flex; align-items:center; gap:8px;
          min-height:29px; padding:6px 10px;
          border:1px solid #d1d5db; border-radius:5px; background:#fff; cursor:pointer; overflow:visible;
        }
        #${WRAP_INT} .v-ms__chips{ display:flex; flex-wrap:wrap; gap:8px; flex:1 1 auto; }
        #${WRAP_INT} .v-ms__placeholder{ color:#9ca3af; font-size:14px; font-weight:400 !important; }
        #${WRAP_INT} .v-ms__chip{ display:inline-flex; align-items:center; gap:6px; padding:6px 10px; border-radius:8px; background:#66A443; color:#fff; border:0; cursor:pointer; }
        #${WRAP_INT} .v-ms__chipX{ font-weight:700; }
        #${WRAP_INT} .v-ms__menu{
          position:absolute; left:0; right:0; top:inherit; margin-top:0; max-height:280px; overflow:auto;
          border:1px solid #e5e7eb; border-radius:8px; background:#fff; box-shadow:0 10px 30px rgba(0,0,0,.12); z-index:9999;
        }
        #${WRAP_INT} .v-ms__option{ display:flex; align-items:center; gap:10px; padding:10px 12px; cursor:pointer; }
        #${WRAP_INT} .v-ms__option[aria-selected="true"]{ background:#f3f4f6; }
        #${WRAP_INT} .v-ms__option:hover{ background:#f9fafb; }
        #${WRAP_INT} .v-ms__check{ pointer-events:none; width:inherit; }

        /* Dropdown shared (normal font when selected) */
        #${WRAP_GEN} .v-sel__value,
        #${WRAP_CTRY} .v-ct__value,
        #${WRAP_PROV} .v-pv__value{ font-weight:400 !important; }

        /* Gender (single-select) */
        #${WRAP_GEN}{ position:relative; font:inherit; }
        #${WRAP_GEN} .v-sel__label{ display:block; margin:0 0 6px; color:#6b7280; font-size:14px; }
        #${WRAP_GEN} .v-sel__control{
          display:flex; align-items:center; justify-content:space-between;
          min-height:43px; width:100%; padding:6px 10px;
          border:1px solid #d1d5db; border-radius:5px; background:#fff; cursor:pointer; font-weight:normal !important;
        }
        #${WRAP_GEN} .v-sel__value{ color:#111827; }
        #${WRAP_GEN} .v-sel__placeholder{ color:#9ca3af; font-weight:400 !important; }
        #${WRAP_GEN} .v-sel__menu{
          position:absolute; left:0; right:0; top:inherit; margin-top:0; max-height:280px; overflow:auto;
          border:1px solid #e5e7eb; border-radius:8px; background:#fff; box-shadow:0 10px 30px rgba(0,0,0,.12); z-index:9999;
        }
        #${WRAP_GEN} .v-sel__option{ padding:10px 12px; cursor:pointer; }
        #${WRAP_GEN} .v-sel__option[aria-selected="true"]{ background:#f3f4f6; }
        #${WRAP_GEN} .v-sel__option:hover{ background:#f9fafb; }
        #${WRAP_GEN} .v-sel__option[aria-current="true"]{ background:#e5e7eb; }

        /* Country (single-select) */
        #${WRAP_CTRY}{ position:relative; font:inherit; }
        #${WRAP_CTRY} .v-ct__label{ display:block; margin:0 0 6px; color:#6b7280; font-size:14px; }
        #${WRAP_CTRY} .v-ct__control{
          display:flex; align-items:center; justify-content:space-between;
          min-height:43px; width:100%; padding:6px 10px;
          border:1px solid #d1d5db; border-radius:5px; background:#fff; cursor:pointer; font-weight:normal !important;
        }
        #${WRAP_CTRY} .v-ct__value{ color:#111827; }
        #${WRAP_CTRY} .v-ct__placeholder{ color:#9ca3af; font-weight:400 !important; }
        #${WRAP_CTRY} .v-ct__menu{
          position:absolute; left:0; right:0; top:inherit; margin-top:0; max-height:280px; overflow:auto;
          border:1px solid #e5e7eb; border-radius:8px; background:#fff; box-shadow:0 10px 30px rgba(0,0,0,.12); z-index:9999;
        }
        #${WRAP_CTRY} .v-ct__option{ padding:10px 12px; cursor:pointer; }
        #${WRAP_CTRY} .v-ct__option[aria-selected="true"]{ background:#f3f4f6; }
        #${WRAP_CTRY} .v-ct__option:hover{ background:#f9fafb; }
        #${WRAP_CTRY} .v-ct__option[aria-current="true"]{ background:#e5e7eb; }

        /* Province (single-select) */
        #${WRAP_PROV}{ position:relative; font:inherit; }
        #${WRAP_PROV} .v-pv__label{ display:block; margin:0 0 6px; color:#6b7280; font-size:14px; }
        #${WRAP_PROV} .v-pv__control{
          display:flex; align-items:center; justify-content:space-between;
          min-height:43px; width:100%; padding:6px 10px;
          border:1px solid #d1d5db; border-radius:5px; background:#fff; cursor:pointer; font-weight:normal !important;
          opacity:1;
        }
        #${WRAP_PROV}[data-disabled="true"] .v-pv__control{
          opacity:.55; cursor:not-allowed;
        }
        #${WRAP_PROV} .v-pv__value{ color:#111827; }
        #${WRAP_PROV} .v-pv__placeholder{ color:#9ca3af; font-weight:400 !important; }
        #${WRAP_PROV} .v-pv__menu{
          position:absolute; left:0; right:0; top:inherit; margin-top:0; max-height:280px; overflow:auto;
          border:1px solid #e5e7eb; border-radius:8px; background:#fff; box-shadow:0 10px 30px rgba(0,0,0,.12); z-index:9999;
        }
        #${WRAP_PROV} .v-pv__option{ padding:10px 12px; cursor:pointer; }
        #${WRAP_PROV} .v-pv__option[aria-selected="true"]{ background:#f3f4f6; }
        #${WRAP_PROV} .v-pv__option:hover{ background:#f9fafb; }
        #${WRAP_PROV} .v-pv__option[aria-current="true"]{ background:#e5e7eb; }

        /* Success banner styling */
        section[data-testid="banner-success"]{
          background:#f4f4f4;
          border-radius:12px;
          padding:48px 24px;
          text-align:center;
          max-width:100%;
        }
        section[data-testid="banner-success"] h2{
          margin:0 0 14px;
          font-weight:700;
          line-height:1.1;
          font-size: clamp(28px, 4.2vw, 52px);
        }
        section[data-testid="banner-success"] ._textBody_2aowh_10 p{
          margin:0 0 22px !important;
        }
        section[data-testid="banner-success"] a{
          font-size: 12px;
          line-height: 1.25;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 1px;
          display: inline-flex;
          justify-content: center;
          align-items: center;
          border: 0;
          cursor: pointer;
          font: inherit;
          text-decoration: none;
          color: #fff !important;
          background-color: #66A443 !important;
          padding: 14px 28px;
          border-radius: 10px;
        }
        section[data-testid="banner-success"] [class*="_copyToClipboardButton"] [class*="_copyToClipboardText"] {
          color: #66A443;
        }
        section[data-testid="banner-success"] [class*="_copyToClipboardButton"] svg path {
          fill: #66A443;
        }
        shop-discount-auth {
          display: none;
        }
      `;
      let style = sr.getElementById(STYLE_ID);
      if (!style){ style = document.createElement('style'); style.id = STYLE_ID; sr.appendChild(style); }
      style.textContent = css;
      sr.appendChild(style); // keep last to win cascade
    }

    /* ---------- Section Headings ---------- */
    function ensureSectionHeadings(sr){
      const form = $(sr,'form[data-testid="form"]'); if(!form) return;

      const ensureHeadingBefore = (containerEl, id, text) => {
        if (!containerEl) return;
        if (containerEl.previousElementSibling && containerEl.previousElementSibling.id === id) return;
        const h = document.createElement('h3');
        h.id = id; h.className = 'v-section-title'; h.textContent = text;
        containerEl.before(h);
      };

      const containerOfDirectChild = (node) => {
        if (!node) return null;
        let el = node.nodeType === 1 ? node : node.parentElement;
        while (el && el.parentElement !== form) el = el.parentElement;
        return (el && el.parentElement === form) ? el : null;
      };

      // Personal Information (above First name)
      const firstLabel = $$(form, 'label, legend').find(l => /first\s*name/i.test((l.textContent || '').trim()));
      const firstField  = firstLabel || form.querySelector('input[name*="first" i]');
      const firstCont   = containerOfDirectChild(firstField);
      if (firstCont) ensureHeadingBefore(firstCont, 'vSectionPersonalInfo', 'Personal Information');

      // Address (above virtual Country or original country input)
      const vc = sr.getElementById(WRAP_CTRY);
      if (vc) {
        ensureHeadingBefore(vc, 'vSectionAddress', 'Address');
      } else {
        const cInput = findCountryInput(form);
        const cont = containerOfDirectChild(cInput);
        if (cont) ensureHeadingBefore(cont, 'vSectionAddress', 'Address');
      }

      // Interest (above virtual Interest)
      const vInterestWrap = sr.getElementById(WRAP_INT);
      if (vInterestWrap) ensureHeadingBefore(vInterestWrap, 'vSectionInterest', 'Interest');
    }

    /* ---------- Interest (multi-select) ---------- */
    function ensureVirtualInterest(sr){
      const form = $(sr,'form[data-testid="form"]'); if(!form) return;
      const fs = $(form,'fieldset[name="custom#interest"], fieldset[name*="interest" i]');
      if (!fs || sr.getElementById(WRAP_INT)) return;

      const inputs = $$(fs,'input[type="checkbox"]'); if(!inputs.length) return;
      const opts = inputs.map(input=>{
        const id=input.id;
        const lab=(id && $(fs,`label[for="${CSS.escape(id)}"]`))||input.closest('label');
        return { value: input.value ?? (lab?.textContent||'').trim(),
                label: (lab?.textContent||input.value||'').trim(), input };
      });

      const wrap=document.createElement('div');
      wrap.id=WRAP_INT; wrap.className='v-ms';
      const legend=($(fs,'legend')?.textContent||'Interest').trim();
      const required=inputs.some(i=>i.required||i.getAttribute('aria-required')==='true');
      wrap.innerHTML=`
        <label class="v-ms__label" aria-hidden="true">${legend}${required?'<sup>*</sup>':''}</label>
        <div class="v-ms__control" role="combobox" aria-expanded="false" aria-haspopup="listbox" tabindex="0">
          <div class="v-ms__chips"></div><span class="v-ms__caret" aria-hidden="true">▾</span>
        </div>
        <div class="v-ms__menu" role="listbox" aria-multiselectable="true" hidden></div>`;
      fs.before(wrap); fs.style.display='none';

      const control=$(wrap,'.v-ms__control'), chips=$(wrap,'.v-ms__chips'), menu=$(wrap,'.v-ms__menu');

      opts.forEach(o=>{
        const row=document.createElement('div');
        row.className='v-ms__option'; row.setAttribute('role','option'); row.dataset.value=o.value;
        row.innerHTML=`<input class="v-ms__check" type="checkbox" tabindex="-1"/><span class="v-ms__text">${o.label}</span>`;
        menu.appendChild(row);
      });

      const allOpt = opts.find(o=>/^all$/i.test(o.label));

      function syncFromOriginal(){
        if (EXCLUSIVE_ALL && allOpt && allOpt.input.checked){ opts.forEach(o=>{ if(o!==allOpt) o.input.checked=false; }); }
        else if (EXCLUSIVE_ALL && allOpt){ if (opts.some(o=>o!==allOpt && o.input.checked)) allOpt.input.checked=false; }

        $$(menu,'.v-ms__option').forEach(row=>{
          const o=opts.find(x=>x.value===row.dataset.value);
          const on=!!o?.input.checked;
          $(row,'.v-ms__check').checked=on;
          row.setAttribute('aria-selected', on?'true':'false');
        });

        chips.innerHTML='';
        const sel=opts.filter(o=>o.input.checked);
        if(!sel.length){
          chips.innerHTML=`<span class="v-ms__placeholder">Select…</span>`;
        } else {
          sel.forEach(o=>{
            const chip=document.createElement('button');
            chip.type='button'; chip.className='v-ms__chip';
            chip.innerHTML=`${o.label} <span class="v-ms__chipX" aria-hidden="true">×</span>`;
            chip.addEventListener('click',()=>{
              o.input.checked=false;
              o.input.dispatchEvent(new Event('change',{bubbles:true}));
              syncFromOriginal();
            });
            chips.appendChild(chip);
          });
        }
      }

      function toggle(val){
        const o=opts.find(x=>x.value===val); if(!o) return;
        if (EXCLUSIVE_ALL && allOpt && o===allOpt){
          const next=!o.input.checked;
          opts.forEach(x=>x.input.checked=false);
          o.input.checked=next;
        } else {
          o.input.checked=!o.input.checked;
          if (EXCLUSIVE_ALL && allOpt) allOpt.input.checked=false;
        }
        o.input.dispatchEvent(new Event('change',{bubbles:true}));
        syncFromOriginal();
      }

      const open=()=>{ menu.hidden=false; control.setAttribute('aria-expanded','true'); };
      const close=()=>{ menu.hidden=true; control.setAttribute('aria-expanded','false'); };
      const toggleMenu=()=> menu.hidden?open():close();

      control.addEventListener('click',toggleMenu);
      control.addEventListener('keydown',e=>{
        if(['Enter',' '].includes(e.key)){ e.preventDefault(); toggleMenu(); }
        if(e.key==='Escape') close();
        if(e.key==='ArrowDown' && menu.hidden){ e.preventDefault(); open(); }
      });
      menu.addEventListener('click',e=>{
        const row=e.target.closest('.v-ms__option'); if(!row) return;
        toggle(row.dataset.value);
      });
      sr.addEventListener('mousedown',e=>{ if(!wrap.contains(e.target)) close(); });
      fs.addEventListener('change',syncFromOriginal);
      syncFromOriginal();
    }

    /* ---------- Gender (single-select, Enter selects) ---------- */
    function ensureVirtualGender(sr){
      const form = $(sr,'form[data-testid="form"]'); if(!form) return;
      const genderFs = $$(form,'fieldset').find(s => /gender/i.test(s.querySelector('legend')?.textContent || ''));
      if (!genderFs || sr.getElementById(WRAP_GEN)) return;

      const radios = $$(genderFs,'input[type="radio"]'); if(!radios.length) return;
      const name = radios[0].name;
      const opts = radios.map(r=>{
        const id=r.id;
        const lab=(id && $(genderFs,`label[for="${CSS.escape(id)}"]`))||r.closest('label');
        return { value: r.value || (lab?.textContent||'').trim(), label: (lab?.textContent||r.value||'').trim(), input:r };
      });

      const wrap=document.createElement('div');
      wrap.id=WRAP_GEN;
      const legend=($(genderFs,'legend')?.textContent|| 'Gender').trim();
      const required=radios.some(r=>r.required||r.getAttribute('aria-required')==='true');
      wrap.innerHTML=`
        <label class="v-sel__label">${legend}${required?'<sup>*</sup>':''}</label>
        <button type="button" class="v-sel__control v-dd__control" role="combobox" aria-expanded="false" aria-haspopup="listbox">
          <span class="v-sel__value v-dd__placeholder">Select…</span><span aria-hidden="true">▾</span>
        </button>
        <div class="v-sel__menu v-dd__menu" role="listbox" hidden tabindex="-1"></div>`;
      genderFs.before(wrap); genderFs.style.display='none';

      const control=$(wrap,'.v-sel__control');
      const valueEl=$(wrap,'.v-sel__value');
      const menu=$(wrap,'.v-sel__menu');

      opts.forEach(o=>{
        const row=document.createElement('div');
        row.className='v-sel__option v-dd__option'; row.setAttribute('role','option'); row.dataset.value=o.value;
        row.textContent=o.label; menu.appendChild(row);
      });
      const rows = $$(menu,'.v-sel__option');

      let activeIndex = -1;
      const setActive = (i) => {
        if (!rows.length) return;
        i = Math.max(0, Math.min(i, rows.length - 1));
        if (activeIndex >= 0) rows[activeIndex].removeAttribute('aria-current');
        rows[i].setAttribute('aria-current', 'true');
        rows[i].scrollIntoView({ block: 'nearest' });
        activeIndex = i;
      };

      // type-to-search + Enter
      let typeBuf = '', lastType = 0;
      const onKey = (e) => {
        const { key } = e;
        if (key === 'Escape') { e.preventDefault(); if (!menu.hidden) { menu.hidden=true; control.setAttribute('aria-expanded','false'); control.focus({preventScroll:true}); } return; }
        if (key === 'Enter')  { 
          if (menu.hidden) { e.preventDefault(); menu.hidden=false; control.setAttribute('aria-expanded','true'); const idx = rows.findIndex(r => r.getAttribute('aria-selected') === 'true'); setActive(idx >= 0 ? idx : 0); menu.focus({ preventScroll: true }); }
          else { e.preventDefault(); if (activeIndex >= 0) choose(rows[activeIndex].dataset.value); }
          return;
        }
        if (key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey){
          const now = Date.now();
          if (now - lastType > 700) typeBuf = '';
          typeBuf += key; lastType = now;
          const q = typeBuf.toLowerCase();
          const idx = rows.findIndex(r => (r.textContent||'').trim().toLowerCase().startsWith(q));
          if (idx >= 0) setActive(idx);
          return;
        }
        if (['ArrowDown','ArrowUp','Home','End'].includes(key)){
          e.preventDefault();
          if (menu.hidden) { menu.hidden=false; control.setAttribute('aria-expanded','true'); const idx = rows.findIndex(r => r.getAttribute('aria-selected') === 'true'); setActive(idx >= 0 ? idx : 0); menu.focus({preventScroll:true}); }
          else {
            if (key === 'ArrowDown') setActive(activeIndex < 0 ? 0 : activeIndex + 1);
            if (key === 'ArrowUp')   setActive(activeIndex < 0 ? 0 : activeIndex - 1);
            if (key === 'Home')      setActive(0);
            if (key === 'End')       setActive(rows.length - 1);
          }
        }
      };

      function syncFromOriginal(){
        const checked = opts.find(o=>o.input.checked);
        rows.forEach((row, i)=>{
          const isSel = row.dataset.value === (checked?.value||'');
          row.setAttribute('aria-selected', isSel ? 'true' : 'false');
          if (isSel && menu.hidden) activeIndex = i;
        });
        if (checked){
          valueEl.textContent = checked.label;
          valueEl.classList.remove('v-dd__placeholder');
        } else {
          valueEl.textContent = 'Select…';
          valueEl.classList.add('v-dd__placeholder');
        }
      }

      function choose(val){
        const o = opts.find(x=>x.value===val); if(!o) return;
        $$(sr, `input[type="radio"][name="${CSS.escape(name)}"]`).forEach(x=> x.checked = (x === o.input));
        o.input.dispatchEvent(new Event('change',{bubbles:true}));
        syncFromOriginal(); menu.hidden=true; control.setAttribute('aria-expanded','false'); control.focus({preventScroll:true});
      }

      control.addEventListener('click', ()=> onKey(new KeyboardEvent('keydown',{key: menu.hidden?'Enter':'Escape'})));
      control.addEventListener('keydown', onKey);
      menu.addEventListener('keydown', onKey);
      menu.addEventListener('click',e=>{ const row=e.target.closest('.v-sel__option'); if(!row) return; choose(row.dataset.value); });
      sr.addEventListener('mousedown',e=>{ if(!wrap.contains(e.target)) { menu.hidden=true; control.setAttribute('aria-expanded','false'); } });
      genderFs.addEventListener('change',syncFromOriginal);
      syncFromOriginal();
    }

    /* ---------- Country (writes CODE) + Province (writes CODE) ---------- */
    function findCountryInput(form){
      return (
        form.querySelector('input#custom\\#country') ||
        form.querySelector('input[name="custom#country"]') ||
        form.querySelector('input[id*="country" i]') ||
        form.querySelector('input[name*="country" i]') ||
        form.querySelector('[data-testid*="country" i] input')
      );
    }
    function findProvinceInput(form){
      return (
        form.querySelector('input#custom\\#province') ||
        form.querySelector('input[name="custom#province"]') ||
        form.querySelector('input[id*="province" i]') ||
        form.querySelector('input[id*="state" i]') ||
        form.querySelector('input[name*="province" i]') ||
        form.querySelector('input[name*="state" i]')
      );
    }

    function ensureCountryProvince(sr){
      const form = $(sr,'form[data-testid="form"]'); if(!form) return;
      if (sr.getElementById(WRAP_CTRY)) return;

      if (!COUNTRY_DATA.all.length){
        // No dataset → skip replacing so original inputs keep working.
        return;
      }

      const countryInput = findCountryInput(form);
      if (!countryInput) return;
      const provinceInput = findProvinceInput(form);

      const containerOfDirectChild = (node) => {
        if (!node) return null;
        let el = node.nodeType === 1 ? node : node.parentElement;
        while (el && el.parentElement !== form) el = el.parentElement;
        return (el && el.parentElement === form) ? el : null;
      };
      const cCont = containerOfDirectChild(countryInput);
      const pCont = provinceInput ? containerOfDirectChild(provinceInput) : null;

      // Country UI
      const vC = document.createElement('div');
      vC.id = WRAP_CTRY;
      const cRequired = countryInput.required || countryInput.getAttribute('aria-required') === 'true';
      vC.innerHTML = `
        <label class="v-ct__label">Country${cRequired?'<sup>*</sup>':''}</label>
        <button type="button" class="v-ct__control v-dd__control" role="combobox" aria-expanded="false" aria-haspopup="listbox">
          <span class="v-ct__value v-dd__placeholder">Select…</span><span aria-hidden="true">▾</span>
        </button>
        <div class="v-ct__menu v-dd__menu" role="listbox" hidden tabindex="-1"></div>
      `;
      if (cCont) { cCont.before(vC); cCont.style.display='none'; } else { countryInput.before(vC); countryInput.style.display='none'; }

      const ctControl = $('.'+WRAP_CTRY ? vC : sr, '.v-ct__control') || vC.querySelector('.v-ct__control');
      const ctValue   = vC.querySelector('.v-ct__value');
      const ctMenu    = vC.querySelector('.v-ct__menu');

      COUNTRY_DATA.all.forEach(({name, code})=>{
        const row = document.createElement('div');
        row.className='v-ct__option v-dd__option';
        row.setAttribute('role','option');
        row.dataset.code = code;
        row.textContent = name;
        ctMenu.appendChild(row);
      });

      // Province UI
      let vP=null, pvControl=null, pvValue=null, pvMenu=null, pvRows=[];
      if (provinceInput){
        vP = document.createElement('div');
        vP.id = WRAP_PROV; vP.dataset.disabled = 'true';
        const pRequired = provinceInput.required || provinceInput.getAttribute('aria-required') === 'true';
        vP.innerHTML = `
          <label class="v-pv__label">State / Province${pRequired?'<sup>*</sup>':''}</label>
          <button type="button" class="v-pv__control v-dd__control" role="combobox" aria-expanded="false" aria-haspopup="listbox" aria-disabled="true">
            <span class="v-pv__value v-dd__placeholder">Select…</span><span aria-hidden="true">▾</span>
          </button>
          <div class="v-pv__menu v-dd__menu" role="listbox" hidden tabindex="-1"></div>
        `;
        if (pCont) { pCont.before(vP); pCont.style.display='none'; }
        else { cCont ? cCont.after(vP) : vC.after(vP); provinceInput.style.display='none'; }

        pvControl = vP.querySelector('.v-pv__control');
        pvValue   = vP.querySelector('.v-pv__value');
        pvMenu    = vP.querySelector('.v-pv__menu');
      }

      function openMenu(menu){ menu.hidden=false; menu.previousElementSibling.setAttribute('aria-expanded','true'); menu.focus({preventScroll:true}); }
      function closeMenu(menu){ menu.hidden=true; menu.previousElementSibling.setAttribute('aria-expanded','false'); menu.previousElementSibling.focus({preventScroll:true}); }

      // Country behavior
      let ctRows = $$(ctMenu,'.v-ct__option');
      let ctActive = -1;
      const setCtActive = (i) => {
        ctRows = $$(ctMenu,'.v-ct__option');
        if (!ctRows.length) return;
        i = Math.max(0, Math.min(i, ctRows.length-1));
        if (ctActive >= 0) ctRows[ctActive].removeAttribute('aria-current');
        ctRows[i].setAttribute('aria-current','true');
        ctRows[i].scrollIntoView({block:'nearest'});
        ctActive = i;
      };

      const makeListNav = (menu, getRows, setActive, chooseActive) => {
        let typeBuf = '', lastType = 0;
        const onKey = (e) => {
          const key = e.key;
          if (key === 'Escape'){ e.preventDefault(); if (!menu.hidden) closeMenu(menu); return; }
          if (key === 'Enter'){
            if (menu.hidden){ e.preventDefault(); openMenu(menu); }
            else {
              e.preventDefault();
              const rows = getRows();
              const idx = rows.findIndex(r => r.getAttribute('aria-current') === 'true');
              if (idx >= 0 && chooseActive) chooseActive(rows[idx]);
            }
            return;
          }
          if (key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey){
            const now = Date.now();
            if (now - lastType > 700) typeBuf = '';
            typeBuf += key; lastType = now;
            const rows = getRows();
            const q = typeBuf.toLowerCase();
            const idx = rows.findIndex(r => (r.textContent||'').trim().toLowerCase().startsWith(q));
            if (idx >= 0) setActive(idx);
            return;
          }
          if (['ArrowDown','ArrowUp','Home','End'].includes(key)){
            e.preventDefault();
            const rows = getRows();
            const curr = rows.findIndex(r => r.getAttribute('aria-current') === 'true');
            if (key === 'Home') return setActive(0);
            if (key === 'End')  return setActive(rows.length - 1);
            const next = key === 'ArrowDown' ? (curr < 0 ? 0 : curr + 1) : (curr < 0 ? 0 : curr - 1);
            setActive(Math.max(0, Math.min(rows.length-1, next)));
          }
        };
        return onKey;
      };

      function rebuildProvinceMenu(countryCode){
        if (!vP) return;
        const entry = COUNTRY_DATA.byCode[(countryCode||'').toUpperCase()];
        const provinces = entry ? entry.provinces : [];
        pvMenu.innerHTML = '';
        pvRows = [];

        if (!provinces || !provinces.length){
          // disable
          vP.dataset.disabled = 'true';
          pvControl.setAttribute('aria-disabled','true');
          pvValue.textContent = 'Select…';
          pvValue.classList.add('v-dd__placeholder');
          if (provinceInput){
            provinceInput.value = '';
            provinceInput.dispatchEvent(new Event('input',{bubbles:true}));
            provinceInput.dispatchEvent(new Event('change',{bubbles:true}));
          }
          return;
        }

        provinces.forEach(p => {
          const row = document.createElement('div');
          row.className='v-pv__option v-dd__option';
          row.setAttribute('role','option');
          row.dataset.code = p.code;
          row.textContent = p.name;
          pvMenu.appendChild(row);
        });
        pvRows = $$(pvMenu,'.v-pv__option');

        vP.dataset.disabled = 'false';
        pvControl.removeAttribute('aria-disabled');

        const cur = (provinceInput?.value||'').trim();
        const idx = pvRows.findIndex(r => r.dataset.code === cur);
        if (idx >= 0){
          pvValue.textContent = pvRows[idx].textContent;
          pvValue.classList.remove('v-dd__placeholder');
        } else {
          pvValue.textContent = 'Select…';
          pvValue.classList.add('v-dd__placeholder');
        }
      }

      function syncCountryFromInput(){
        const code = (countryInput.value || '').trim().toUpperCase();
        const rows = $$(ctMenu,'.v-ct__option');
        const idx = rows.findIndex(r => r.dataset.code === code);
        if (idx >= 0){
          ctValue.textContent = rows[idx].textContent;
          ctValue.classList.remove('v-dd__placeholder');
        } else {
          ctValue.textContent = 'Select…';
          ctValue.classList.add('v-dd__placeholder');
        }
        rebuildProvinceMenu(code);
      }

      function chooseCountry(code){
        countryInput.value = code; // write COUNTRY CODE
        countryInput.dispatchEvent(new Event('input',{bubbles:true}));
        countryInput.dispatchEvent(new Event('change',{bubbles:true}));
        syncCountryFromInput();
        closeMenu(ctMenu);
      }

      const onKeyCountry = makeListNav(
        ctMenu,
        () => $$(ctMenu,'.v-ct__option'),
        setCtActive,
        (row) => chooseCountry(row.dataset.code)
      );

      ctControl.addEventListener('click', () => {
        if (ctMenu.hidden){
          openMenu(ctMenu);
          const code = (countryInput.value||'').trim().toUpperCase();
          const rows = $$(ctMenu,'.v-ct__option');
          const idx = rows.findIndex(r => r.dataset.code === code);
          setCtActive(idx >= 0 ? idx : 0);
        } else {
          closeMenu(ctMenu);
        }
      });
      ctControl.addEventListener('keydown', onKeyCountry);
      ctMenu.addEventListener('keydown', onKeyCountry);
      ctMenu.addEventListener('click', e=>{
        const row = e.target.closest('.v-ct__option'); if (!row) return;
        chooseCountry(row.dataset.code);
      });
      sr.addEventListener('mousedown',e=>{ if(!vC.contains(e.target)) closeMenu(ctMenu); });
      countryInput.addEventListener('change', syncCountryFromInput);
      countryInput.addEventListener('input',  syncCountryFromInput);

      // Province behavior
      if (vP){
        let pvRows = [];
        let pvActive = -1;
        const setPvActive = (i) => {
          pvRows = $$(pvMenu,'.v-pv__option');
          if (!pvRows.length) return;
          i = Math.max(0, Math.min(i, pvRows.length-1));
          if (pvActive >= 0) pvRows[pvActive].removeAttribute('aria-current');
          pvRows[i].setAttribute('aria-current','true');
          pvRows[i].scrollIntoView({block:'nearest'});
          pvActive = i;
        };

        const onKeyProvince = makeListNav(
          pvMenu,
          () => $$(pvMenu,'.v-pv__option'),
          setPvActive,
          (row) => chooseProvince(row.dataset.code)
        );

        function chooseProvince(code){
          if (!provinceInput) return;
          provinceInput.value = code; // write PROVINCE CODE
          provinceInput.dispatchEvent(new Event('input',{bubbles:true}));
          provinceInput.dispatchEvent(new Event('change',{bubbles:true}));
          const row = $$(pvMenu,'.v-pv__option').find(r => r.dataset.code === code);
          if (row){
            pvValue.textContent = row.textContent;
            pvValue.classList.remove('v-dd__placeholder');
          }
          closeMenu(pvMenu);
        }

        pvControl.addEventListener('click', ()=>{
          if (vP.dataset.disabled === 'true') return;
          if (pvMenu.hidden){
            openMenu(pvMenu);
            const cur = (provinceInput.value||'').trim();
            const idx = $$(pvMenu,'.v-pv__option').findIndex(r => r.dataset.code === cur);
            setPvActive(idx >= 0 ? idx : 0);
          } else {
            closeMenu(pvMenu);
          }
        });
        pvControl.addEventListener('keydown', onKeyProvince);
        pvMenu.addEventListener('keydown', onKeyProvince);
        pvMenu.addEventListener('click', e=>{
          const row = e.target.closest('.v-pv__option'); if (!row) return;
          chooseProvince(row.dataset.code);
        });
        sr.addEventListener('mousedown',e=>{ if(vP && !vP.contains(e.target)) closeMenu(pvMenu); });
      }

      // Initial sync
      syncCountryFromInput();
    }

    // --- Force-unlock scroll when shop-discount-auth tries to lock it ---
    (function unlockBodyScrollWhenSDAppears(){
      const isSDAActive = () => document.querySelector('shop-discount-auth');

      const forceUnlock = () => {
        // Prefer clearing the inline style; if it keeps coming back, set auto !important
        document.body.style.removeProperty('overflow');
        document.documentElement.style.removeProperty('overflow');

        // If computed overflow is still hidden, smash it with !important
        const b = getComputedStyle(document.body).overflow;
        const h = getComputedStyle(document.documentElement).overflow;
        if (b === 'hidden') document.body.style.setProperty('overflow', 'auto', 'important');
        if (h === 'hidden') document.documentElement.style.setProperty('overflow', 'auto', 'important');

        // Defensive: clear common “page lock” side-effects
        ['position','height','inset','top','left','right','bottom'].forEach(p=>{
          document.body.style.removeProperty(p);
          document.documentElement.style.removeProperty(p);
        });
      };

      // 1) Initial pass
      forceUnlock();

      // 2) Watch for the component being inserted/removed and for body/class style flips
      const domObserver = new MutationObserver(() => {
        if (isSDAActive()) forceUnlock();
      });
      domObserver.observe(document.documentElement, { childList:true, subtree:true });

      const bodyObserver = new MutationObserver((muts) => {
        // If someone flipped overflow to hidden, flip it back
        if ([...muts].some(m => m.type === 'attributes' && (m.attributeName === 'style' || m.attributeName === 'class'))) {
          const locked = getComputedStyle(document.body).overflow === 'hidden' ||
                        getComputedStyle(document.documentElement).overflow === 'hidden';
          if (locked) forceUnlock();
        }
      });
      bodyObserver.observe(document.body, { attributes:true, attributeFilter:['style','class'] });
      bodyObserver.observe(document.documentElement, { attributes:true, attributeFilter:['style','class'] });

      // 3) Optional: stop watching once your success banner is visible
      const stopWhenDone = setInterval(() => {
        if (document.querySelector('section[data-testid="banner-success"]')) {
          domObserver.disconnect(); bodyObserver.disconnect(); clearInterval(stopWhenDone);
          // Clean once more
          forceUnlock();
        }
      }, 500);
    })();

    /* ---------- Boot ---------- */
    waitForOpenShadow(FORMS_ATTR).then((sr) => {
      ensureStyles(sr);
      ensureVirtualInterest(sr);
      ensureVirtualGender(sr);
      ensureCountryProvince(sr);
      ensureSectionHeadings(sr);

      // Re-apply if the form element is replaced
      let formRef = $(sr,'form[data-testid="form"]');
      const mo = new MutationObserver(() => {
        const now = $(sr,'form[data-testid="form"]');
        if (now && now !== formRef) {
          formRef = now;
          ensureStyles(sr);
          ensureVirtualInterest(sr);
          ensureVirtualGender(sr);
          ensureCountryProvince(sr);
          ensureSectionHeadings(sr);
        }
      });
      mo.observe(sr, { childList:true, subtree:true });
    }).catch(() => {
      // If the shadow root is CLOSED, direct styling won't be possible.
    });
  })();